<div class="form-group bb" data-type="range" *ngIf="facetRange != null && facetRange.floor != facetRange.ceil">
  <label for="model">{{ facetName }}</label>
  <app-range-slider [(rangeSlider)]="facetRange" [useCommas]="useCommas" (rangeSliderChange)="onChange()"> </app-range-slider>
</div>
